
export const MEETINGS_LIST              = "MEETINGS_LIST";
export const MEETINGS_COUNT             = "MEETINGS_COUNT";
export const VIDEO_RECORDING_LIST           =   'VIDEO_RECORDING_LIST'
export const RECORDING_COUNT                =   'RECORDING_COUNT'